import * as React from 'react';

type Props = {
  currentHistoryRecordId?: string;
  getDatasheetElementsHistorySequence: () => Array<string> | undefined;
};

export const useDatasheetUndoRedoController = (props: Props) => {
  const { currentHistoryRecordId, getDatasheetElementsHistorySequence } = props;

  const datasheetElementsHistorySequence = getDatasheetElementsHistorySequence();

  const canUndo = React.useMemo(() => {
    if (!currentHistoryRecordId || !datasheetElementsHistorySequence) {
      return false;
    }

    const idx = datasheetElementsHistorySequence.indexOf(currentHistoryRecordId);
    if (idx < 0) {
      return false;
    }
    return idx > 0;
  }, [currentHistoryRecordId, datasheetElementsHistorySequence]);

  const canRedo = React.useMemo(() => {
    if (!currentHistoryRecordId || !datasheetElementsHistorySequence) {
      return false;
    }

    const idx = datasheetElementsHistorySequence.indexOf(currentHistoryRecordId);
    if (idx < 0) {
      return false;
    }
    return idx < datasheetElementsHistorySequence.length - 1;
  }, [currentHistoryRecordId, datasheetElementsHistorySequence]);

  return {
    canUndo,
    canRedo,
  };
};